// Shim de auth para el módulo Restauración: reutiliza la sesión de la app
// principal y mapea el rol a los roles internos del módulo ("admin" para
// Administrador/Directora, "viewer" para el resto).
import { useAuth as useMainAuth } from "@/context/AuthContext";

export function useAuth() {
  const main = useMainAuth() || {};
  const u = main.user;
  const isDiningAdmin = !!u && (u.role === "Administrador" || u.role === "Directora");
  return {
    ...main,
    user: u ? { ...u, role: isDiningAdmin ? "admin" : "viewer" } : null,
  };
}
